(function () {
  function init() {
    const headerComponent = document.getElementById('header-component');
    if (!headerComponent) return;
    const translations = window.theme?.strings || {};

    const locale = window.Shopify?.locale || document.documentElement.lang || '';
    const localePrefix = locale && locale !== 'en' ? `/${locale}` : '';

    const hm = headerComponent.querySelector('header-menu');
    if (!hm) return;
    hm.activate = () => {};
    hm.deactivate = () => {};
    hm.style.setProperty('--submenu-height', '0px');
    hm.style.setProperty('--submenu-opacity', '0');

    document.querySelectorAll('#inline-submenu-bar').forEach(b => b.remove());

    const COL_WIDTH = 230;
    const allParents = [...hm.querySelectorAll('.menu-list__link[aria-haspopup]')];

    function getChildLinks(link) {
      const listItem = link.closest('.menu-list__list-item');
      if (!listItem) return [];
      return [...listItem.querySelectorAll('.mega-menu__link')].map(a => ({
        href: a.href,
        text: a.textContent.trim()
      })).filter(l => l.text);
    }

    const parentCols = allParents.filter(p => getChildLinks(p).length);
    const FIXED_WIDTH = (parentCols.length) * COL_WIDTH;

    const bar = document.createElement('div');
    bar.id = 'inline-submenu-bar';
    bar.style.cssText = `
      background: var(--color-background, #ffffff);
      border: 1px solid var(--color-border, rgba(0,0,0,0.1));
      box-shadow: 0 20px 48px rgba(0,0,0,0.10);
      overflow: hidden;
      max-height: 0;
      opacity: 0;
      display: block;
      z-index: 998;
      transition: max-height 0.3s cubic-bezier(0.25,1,0.5,1), opacity 0.25s ease, left 0.2s cubic-bezier(0.25,1,0.5,1);
      box-sizing: border-box;
      position: absolute;
      top: 100%;
      pointer-events: none;
      width: ${FIXED_WIDTH}px;
    `;

    const inner = document.createElement('div');
    inner.style.cssText = `
      display: grid;
      grid-template-columns: repeat(${parentCols.length + 1}, ${COL_WIDTH}px);
      background: var(--color-background, #fff);
      box-sizing: border-box;
      overflow: hidden;
      width: 100%;
    `;

    const style = document.createElement('style');
    style.textContent = `
      #inline-submenu-bar .brand-tagline {
        font-family: 'Instrument Serif', serif !important;
        font-size: 19px !important;
        line-height: 1.4 !important;
        color: var(--color-foreground, #000) !important;
        margin-bottom: 10px !important;
        font-style: italic !important;
      }
    `;
    bar.appendChild(style);

    bar.appendChild(inner);
    headerComponent.style.position = 'relative';
    headerComponent.appendChild(bar);

    let activeLink = null;
    let clickLocked = false;

    function close() {
      if (clickLocked) return;
      if (activeLink) {
        activeLink.classList.remove('active-parent');
      }
      activeLink = null;
      bar.style.maxHeight = '0';
      bar.style.opacity = '0';
      bar.style.pointerEvents = 'none';
    }

    function positionBar(activeParentLink) {
      const headerRect = headerComponent.getBoundingClientRect();
      const parentRect = activeParentLink.getBoundingClientRect();
      let left = parentRect.left - headerRect.left;
      if (left + FIXED_WIDTH > headerRect.width) left = headerRect.width - FIXED_WIDTH;
      if (left < 0) left = 0;
      bar.style.left = left + 'px';
      bar.style.right = 'auto';
    }

    function open(activeParentText) {
      inner.innerHTML = '';

      const reorderedCols = [];
      const activeParent = parentCols.find(p => p.textContent.trim() === activeParentText);
      if (activeParent) {
        reorderedCols.push(activeParent);
        parentCols.forEach(p => { if (p !== activeParent) reorderedCols.push(p); });
      } else {
        reorderedCols.push(...parentCols);
      }

      reorderedCols.forEach((parentLink, index) => {
        const childLinks = getChildLinks(parentLink);

        const col = document.createElement('div');
        col.style.cssText = `
          padding: 26px 22px 30px;
          border-right: 1px solid var(--color-border, rgba(0,0,0,0.08));
          box-sizing: border-box;
          background: transparent;
          transition: background 0.2s ease;
        `;

        const head = document.createElement('a');
        head.href = parentLink.href || '#';
        head.textContent = parentLink.textContent.trim();
        head.style.cssText = `
          display: block;
          font-size: 10px;
          font-weight: 700;
          letter-spacing: .13em;
          text-transform: uppercase;
          color: var(--color-foreground-muted, #888);
          margin-bottom: 14px;
          text-decoration: none;
          cursor: pointer;
        `;
        head.addEventListener('click', e => e.stopPropagation());
        col.appendChild(head);

        childLinks.forEach(({ href, text }, idx) => {
          const a = document.createElement('a');
          a.href = href;
          a.textContent = text;
          const isFirst = idx === 0;
          a.style.cssText = `
            display: block;
            padding: 7px 0;
            font-size: ${isFirst ? '11px' : '13px'};
            font-weight: ${isFirst ? '700' : '500'};
            color: var(--color-foreground, #000);
            text-decoration: none;
            border-bottom: ${isFirst ? '1px solid var(--color-border, rgba(0,0,0,0.1))' : 'none'};
            margin-bottom: ${isFirst ? '4px' : '0'};
            letter-spacing: ${isFirst ? '.05em' : 'normal'};
            text-transform: ${isFirst ? 'uppercase' : 'none'};
            white-space: nowrap;
            transition: color 0.15s, padding-left 0.15s;
          `;
          a.addEventListener('mouseenter', () => { if (!isFirst) a.style.paddingLeft = '5px'; });
          a.addEventListener('mouseleave', () => { if (!isFirst) a.style.paddingLeft = '0'; });
          a.addEventListener('click', e => e.stopPropagation());
          col.appendChild(a);
        });

        inner.appendChild(col);
      });

      /*
      const brandCol = document.createElement('div');
      brandCol.style.cssText = `
        padding: 26px 22px 30px;
        background: rgba(0,0,0,0.02);
        box-sizing: border-box;
      `;
      brandCol.innerHTML = `
        <span style="display:block;font-size:10px;font-weight:700;letter-spacing:.13em;text-transform:uppercase;color:var(--color-foreground-muted,#888);margin-bottom:10px;">${translations['header.our_story'] || 'Our story'}</span>
        <div class="brand-tagline">${translations['header.tagline'] || 'Three generations of craft.'}</div>
        <div style="font-size:12px;color:var(--color-foreground-muted,#888);line-height:1.65;margin-bottom:14px;">${translations['header.description'] || 'Leather footwear built to last a lifetime.'}</div>
        <a href="${localePrefix}/pages/about-us" onclick="event.stopPropagation()" style="font-size:11px;font-weight:700;letter-spacing:.07em;text-transform:uppercase;color:var(--color-foreground,#000);text-decoration:none;display:inline-flex;align-items:center;gap:5px;">
          ${translations['header.read_our_story'] || 'Read our story'}
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
        </a>
      `;
      inner.appendChild(brandCol);
      */

      bar.style.maxHeight = 'none';
      bar.style.opacity = '1';
      bar.style.pointerEvents = 'auto';
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          bar.style.maxHeight = bar.scrollHeight + 'px';
        });
      });
    }

    function activateLink(link) {
      if (activeLink && activeLink !== link) {
        activeLink.classList.remove('active-parent');
      }
      activeLink = link;
      link.classList.add('active-parent');
      positionBar(link);
      open(link.textContent.trim());
    }

    hm.addEventListener('click', (e) => {
      const link = e.target.closest('.menu-list__link[aria-haspopup]');
      if (!link) return;
      
      const hasChildren = getChildLinks(link).length > 0;
      
      if (!hasChildren) {
        return; // Navigate normally
      }
      
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      if (activeLink === link) {
        clickLocked = !clickLocked;
        if (!clickLocked && !bar.matches(':hover')) close();
        return;
      }
      
      clickLocked = true;
      activateLink(link);
    });

    [bar].forEach(el => {
      el.addEventListener('mouseleave', () => {
        if (!hm.matches(':hover') && !bar.matches(':hover')) {
          clickLocked = false;
          close();
        }
      });
    });

    document.addEventListener('click', (e) => {
      if (!activeLink) return;
      setTimeout(() => {
        if (!hm.contains(e.target) && !bar.contains(e.target)) {
          clickLocked = false;
          close();
        }
      }, 50);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { clickLocked = false; close(); }
    });

    window.addEventListener('resize', () => {
      if (activeLink) positionBar(activeLink);
    });

    const observer = new MutationObserver(() => {
      if (!document.getElementById('inline-submenu-bar')) headerComponent.appendChild(bar);
    });
    observer.observe(headerComponent, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(init, 0));
  } else {
    setTimeout(init, 0);
  }
})();